module.exports = __webpack_public_path__ + "static/img/6-1.5319bbf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/6-1.png
// module id = fG7K
// module chunks = 0